var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({class:_vm.buttonClasses,style:(_vm.inlineStyle),attrs:{"type":"button","title":_vm.title,"disabled":_vm.disabled,"aria-label":_vm.title || _vm.icon},on:{"click":function($event){return _vm.$emit('click', $event)}}},'button',_vm.$attrs,false),[(_vm.icon)?_c('i',{class:_vm.iconClass}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }